import React from 'react';
import Form from 'react-bootstrap/Form';

const SearchBoxComponent = ({ searchTextEntered }) => {
    return (
        <div className="searchBoxContainer">
            <div className="searchModeSelector mb-3">

            </div>
            <Form.Control
                type="text"
                placeholder={"Enter app name"}
                onChange={searchTextEntered}
                className="searchBox"
            />
        </div>
    );
};

export default SearchBoxComponent;